import { render } from "./PasswordField.vue?vue&type=template&id=4ed2c755"
import script from "./PasswordField.vue?vue&type=script&lang=js"
export * from "./PasswordField.vue?vue&type=script&lang=js"

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PasswordField.vue"]])

export default __exports__